module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "min-height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_c('div', {
    style: (_vm.login_bk_bj)
  }, [_c('div', {
    staticClass: "login-opactiy2"
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "Systemlogin-container"
  }, [_c('div', {
    staticClass: "systemLogin"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0 13%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      "autoComplete": "on",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "display": "inline-block",
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.gets('$系统登录')))]), _vm._v(" "), _c('lang-select', {
    staticClass: "set-language right lan"
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_login"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "user"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets('$登录名称')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.gets('$输入{登录名}')
    },
    model: {
      value: (_vm.loginPage.LoginName.value),
      callback: function($$v) {
        _vm.$set(_vm.loginPage.LoginName, "value", $$v)
      },
      expression: "loginPage.LoginName.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "svg-container"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "password"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets('$密码')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": _vm.gets('$输入{密码}')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      }
    },
    model: {
      value: (_vm.loginPage.Password.value),
      callback: function($$v) {
        _vm.$set(_vm.loginPage.Password, "value", $$v)
      },
      expression: "loginPage.Password.value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "show-pwd"
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "eye"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "name": "记住密码"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.gets('$记住密码')))])], 1), _vm._v(" \r\n\r\n                            " + _vm._s(_vm.loginPage.LoginName.error) + "\r\n                            " + _vm._s(_vm.loginPage.Password.error) + "\r\n                            "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.gets('$登录')))])], 1)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "systemTopText"
  }, [_c('div', {
    staticClass: "systemTopText-one"
  }, [_vm._v("\r\n                        Boost your business\r\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "systemTopText-two"
  }, [_vm._v("\r\n                        with "), _c('img', {
    staticStyle: {
      "width": "40%",
      "margin-left": "2%"
    },
    attrs: {
      "src": require("../assets/img/shipping.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "26px",
      "line-height": "2rem",
      "margin-top": "10%",
      "font-weight": "300"
    }
  }, [_c('div', [_vm._v("\r\n                            Easily find products to sell online\r\n                        ")]), _vm._v(" "), _c('div', [_vm._v("\r\n                            ship them directly to your customers.\r\n                        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "22px",
      "line-height": "2rem",
      "margin-top": "30%",
      "font-weight": "lighter",
      "font-style": "oblique",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/douhao.png"),
      "alt": "",
      "width": "17px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-weight": "lighter"
    }
  }, [_vm._v("\r\n                            It has never been easier to start your own dropshipping\r\n                            "), _c('div', [_vm._v("\r\n                                business with Shipping Revolution. Shipping Revolution\r\n                            ")]), _vm._v(" "), _c('div', [_vm._v("\r\n                                lets you  find products on the world's most popular market-\r\n                            ")]), _vm._v(" "), _c('div', [_vm._v("\r\n                                places,add them to your e-commerce store, and ship them\r\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "end"
    }
  }, [_vm._v("\r\n                                directly to your customers. \r\n                                "), _c('img', {
    attrs: {
      "src": require("../assets/img/douhao2.png"),
      "alt": "",
      "width": "17px"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/MKD-logo3.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1f29528"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/login.vue
// module id = 1297
// module chunks = 169